<div class="container">
  <header class="page-heading mb-lg">
    <span class="legal-eyebrow"><app-icon [name]="article.eyebrowIcon" class="eyebrow-icon"/> {{ article.eyebrow }}</span>
    <h1>{{ article.title }}</h1>
    <p>{{ article.summary }}</p>
    <span class="reading-time"><app-icon name="schedule" class="meta-icon"/> {{ article.readingTime }}</span>
  </header>

  <section class="card mb-lg toc-card">
    <h2 class="section-title">On this page</h2>
    <nav class="toc-grid" aria-label="Table of contents">
      @for (s of article.sections; track s.id) {
        <a [routerLink]="[]" [fragment]="s.id">{{ s.title }}</a>
      }
    </nav>
  </section>

  <section class="card legal-content mb-lg">
    @for (s of article.sections; track s.id) {
      <article class="legal-section" [id]="s.id">
        <h2>{{ s.title }}</h2>
        @for (p of s.paragraphs; track p) {
          <p>{{ p }}</p>
        }
        @if (s.bullets) {
          <ul>
            @for (b of s.bullets; track b) {
              <li>{{ b }}</li>
            }
          </ul>
        }
      </article>
    }
  </section>

  <section class="card mb-lg related-card">
    <h2 class="section-title">Try the calculator</h2>
    <div class="related-links">
      @for (r of article.related; track r.path) {
        <a [routerLink]="r.path" class="related-link">
          <app-icon [name]="r.icon" class="rl-icon"/>
          <span>{{ r.label }}</span>
        </a>
      }
    </div>
  </section>

  <section class="card seo-content">
    <h2 class="section-title">Frequently Asked Questions</h2>
    @for (f of article.faq; track f.question) {
      <div class="faq-item">
        <h3>{{ f.question }}</h3>
        <p>{{ f.answer }}</p>
      </div>
    }
  </section>

  <p class="legal-footnote">
    More free guides on <a routerLink="/learn">the Learn hub</a>, or <a routerLink="/">explore all calculators</a>.
  </p>
</div>
